export const canUseAnimation =
  ["ci", "test"].includes(process.env.REACT_APP_ENV ?? "development") === false;
